/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_MoreInputs */

const en_shopping_more = /** @type {(inputs: Shopping_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More`)
};

const de_shopping_more = /** @type {(inputs: Shopping_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr`)
};

/**
* | output |
* | --- |
* | "More" |
*
* @param {Shopping_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_more = /** @type {((inputs?: Shopping_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_more(inputs)
	return en_shopping_more(inputs)
});